/**
 * TanStack Query hooks for `campaign-dayparting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignDaypartingQueryKeys,
	type CreateCampaignDaypartingBody,
	type ListCampaignDaypartingResponse,
	type CampaignDaypartingRow,
} from "./api";

export function useCampaignDaypartingList(): UseQueryResult<ListCampaignDaypartingResponse, Error> {
	return useQuery({
		queryKey: campaignDaypartingQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignDaypartingCreate(): UseMutationResult<CampaignDaypartingRow, Error, CreateCampaignDaypartingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignDaypartingQueryKeys.all });
		},
	});
}

export function useCampaignDaypartingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignDaypartingQueryKeys.all });
		},
	});
}
